// src/components/VetProfileCard.js
import React from "react";
import "./VetProfileCard.css";
import { buildUrlWithUTM } from "../utils/utmHelper";

const VetProfileCard = ({ image, name, rating, experience, specialty }) => {
  return (
    <div className="vet-profile-card">
      <a href={buildUrlWithUTM("https://doodley.in/BookHomeVisit")}>
        <img src={image} alt={name} className="vet-photo" />
        <div className="vet-details">
          <div className="vet-name-rating">
            <h3>{name}</h3>
            <div>
              <span>{rating} ★</span>
            </div>
          </div>
          <p>
            <span className="experience">Experience : </span>
            {experience}
          </p>
          <p className="specialty">{specialty}</p>
        </div>
      </a>
    </div>
  );
};

export default VetProfileCard;
